<template>
    <div>
        Nombre de joueurs : <input class="input is-large" type="number" v-model="nbJoueurs"/><br/>
        Nombre de joueurs par pool : <input class="input is-large" type="number" v-model="nbJoueursParPool"/><br/>
        Nombre de joueurs min par pool : <input class="input is-large" type="number" v-model="nbMinJoueursParPool"/><br/>
        Ajouter un nombre de pool :
        <input type="number" v-model="addNbPool" class="input is-large"/>
        Il manque : {{manqueNbPool}}  poules pour avoir un multiple de 4
        <br/>
        <s-button label="GO" @onclick="init" /><br/>
        
        <s-button label="Random WIN" @onclick="randomWinEquipe" /><br/>
        
        <s-button label="ADD POULE" @onclick="addPoule" /><br/>
        TOUR 1<br/>
        <div v-for="(pool, indexPool) in jsonTirage" class="pool">
            <div><b>POOL {{indexPool}}</b></div><hr/>
            <div v-for="equipe in pool.parties[0].equipes">
                {{equipe.joueurs.J1}} 
                <s-button @onclick="win(equipe, 'joueur')" :theme="theme(equipe, 'joueur')"/>
                <b>VS</b> 
                {{equipe.contre.J1}}
                <s-button @onclick="win(equipe, 'contre')" :theme="theme(equipe, 'contre')"/><hr/>
            </div>
        </div>
       <hr/> <s-button label="TIRAGE DU TOUR 2" @onclick="initTour2()"/>
        <br/>TOUR 2<br/>
        <div v-for="(pool, indexPool) in jsonTirage"  class="pool" >
            <div><b>POOL {{indexPool}}</b></div><hr/>
            <span v-if="pool.parties[1]">
            <div v-for="equipe in pool.parties[1].equipes" >
                {{equipe.joueurs.J1}} 
                <s-button @onclick="win(equipe, 'joueur')" :theme="theme(equipe, 'joueur')"/>
                <b>VS</b> 
                {{equipe.contre.J1}}
                <s-button @onclick="win(equipe, 'contre')" :theme="theme(equipe, 'contre')"/><hr/>
            </div>
            </span>
        </div>
        <br/><s-button label="TIRAGE DES BARAGES" @onclick="initBarage()"/>
        <br/>BARAGE<br/>
        <div v-for="(pool, indexPool) in jsonTirage"  class="pool" >
            <div><b>POOL {{indexPool}}</b></div><hr/>
            <span v-if="pool.parties[2]">
            <div v-for="equipe in pool.parties[2].equipes" >
                {{equipe.joueurs.J1}} 
                <s-button @onclick="win(equipe, 'joueur')" :theme="theme(equipe, 'joueur')"/>
                <b>VS</b> 
                {{equipe.contre.J1}}
                <s-button @onclick="win(equipe, 'contre')" :theme="theme(equipe, 'contre')"/><hr/>
            </div>
            </span>
        </div>
        <br/><s-button label="Les qualifiés" @onclick="qualifie()"/>
        <br/>Les qualifies sont :<br/>
        {{jsonQualifie}}
         <br/><s-button label="Eliminatoire" @onclick="initEliminatoire()"/>
        <div v-for="(eliminatoireItem, indexEliminatoire) in jsonEliminatoire">
            <br/><b>ELIMNIATOIRE {{eliminatoireItem}} </b><br/>
            <div v-for="equipe in eliminatoireItem.equipes" class="pool">
                {{equipe.joueurs.J1}} 
                <s-button @onclick="win(equipe, 'joueur')" :theme="theme(equipe, 'joueur')"/>
                <b>VS</b>
                {{equipe.contre.J1}} 
                <s-button @onclick="win(equipe, 'contre')" :theme="theme(equipe, 'contre')"/>
            </div>
             <br/><s-button label="SET ELIMINATOIRE" @onclick="setEliminatoire(indexEliminatoire+1)"/>
             <br/><s-button label="CADRAGE" @onclick="addCadrage()"/>
        </div>
    </div>
</template>
<style scoped>
    .pool {
        border: thin solid black;
        background-color: bisque;
        border-radius: 20px;
        margin: 20px;
        padding: 5px;
        display: inline-block;
    }
</style>
<script>
import TiragePool from "@/firebase/championnat/tirage"
export default {
    data() {
        return {
            nbJoueurs: 40,
            jsonTirage: [],
            nbMinJoueursParPool: 3,
            nbJoueursParPool: 4,
            jsonQualifie: {},
            jsonEliminatoire: [],
            manqueNbPool: 0,
            nbPool: 0,
            addNbPool: 0
        }
    },
    methods: {
        randomWinEquipe() {
            this.jsonTirage.forEach(pool=>{
                var partie = pool.parties[pool.parties.length-1];
                partie.equipes.forEach(equipe=>{
                    this.win(equipe, "joueur");
                })
            })
        },
        random(min, max) {
            return Math.floor(min + Math.random() * (max - min));
        },
        win(equipe, vs) {
            var adv = vs=="contre" ? "joueur" : "contre";
            equipe.score[vs] = 13;
            equipe.score[adv] = this.random(0,12);
        }
        ,
        theme(equipe, vs) {
            if (equipe.score[vs] == 13) {
                return "is-small is-success"
            }
            else
                return "is-small is-light"
        },
        qualifie() {
            var options = {
             nbJoueursParPool: this.nbJoueursParPool,


            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitPool( this.jsonTirage);
            this.jsonQualifie = tirage.qualifie();
        },
        addPoule () {
            var options = {
            nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            var nbPoolRecalcul = parseInt(this.nbPool) + parseInt(this.addNbPool);
            tirage.initPools(nbPoolRecalcul);
            tirage.init();
            var howNbPools = tirage.howNbPools()
            this.manqueNbPool = howNbPools.manqueNbPool;
            this.nbPool = howNbPools.nbPool;
            console.log(tirage.getJson());
            this.jsonTirage = tirage.getJson();
        },
        init() {
            var options = {
            nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.initPools();
            tirage.init();
            var howNbPools = tirage.howNbPools()
            this.manqueNbPool = howNbPools.manqueNbPool;
            this.nbPool = howNbPools.nbPool;
            console.log(tirage.getJson());
            this.jsonTirage = tirage.getJson();
        },
        initTour2() {
            var options = {
             nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitPool( this.jsonTirage);
            tirage.init_TOUR2();
            console.log(tirage.getJson());
            this.jsonTirage = tirage.getJson();
        },
         initBarage() {
            var options = {
            nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitPool( this.jsonTirage);
            tirage.init_BARAGE();
            console.log(tirage.getJson());
            this.jsonTirage = tirage.getJson();
        },
        initEliminatoire() {
            var options = {
             nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitPool( this.jsonTirage);
            this.jsonQualifie = tirage.qualifie();
            tirage.initEliminatoire(this.jsonQualifie);
          // console.log(tirage.getJsonEliminatoire());
            this.jsonEliminatoire = tirage.getJsonEliminatoire();
        },
        setEliminatoire(index) {
            var options = {
             nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitEliminatoire( this.jsonEliminatoire);
            tirage.setEliminatoire(index);
          // console.log(tirage.getJsonEliminatoire());
            this.jsonEliminatoire = tirage.getJsonEliminatoire();
        },
        addCadrage() {
            var options = {
             nbJoueursParPool: this.nbJoueursParPool,
            nbMinJoueursParPool: this.nbMinJoueursParPool,
            nbJoueurs: this.nbJoueurs,
            nbTourPool: 1
            }
            var tirage = new TiragePool(options);
            tirage.reinitEliminatoire( this.jsonEliminatoire);
            tirage.addCadrage();
          // console.log(tirage.getJsonEliminatoire());
            this.jsonEliminatoire = tirage.getJsonEliminatoire();
        }
    }
}
</script>